<template>
  <x-page title="退款/售后" :embed="embed">
    <x-waterfall :load="handleLoad" :no-complete-tips="noCompleteTips">
      <template #default="{ data }">
        <x-card
          v-for="item in data"
          :key="item.id"
          v-track="{
            name: '售后列表-条目',
            id: '9806832b-12b8-4efe-99e0-61a11fcf5e60',
          }"
          @click.native="handleItemClick(item)"
        >
          <div class="hd">
            <div class="no">售后编号：{{ item.id }}</div>
            <div class="type">{{ AfterSalesType[item.saleAfterType] }}</div>
          </div>
          <div class="bd">
            <van-image :src="item.commodityCoverPic" class="cover" />
            <div class="content">
              <div :class="['name', _._ellipsis2]">
                {{ item.commodityTitle }}
              </div>
              <div class="desc">{{ item.commoditySpecs }}</div>
              <div class="extra">退款：¥{{ item.refundAmount }}</div>
            </div>
            <div class="info">
              <div class="price">￥{{ item.unitPrice }}</div>
              <div class="amount">x{{ item.quantity }}</div>
            </div>
          </div>
          <div class="ft">
            <div class="content">{{ item.description }}</div>
            <van-icon name="arrow" class="arrow" />
          </div>
        </x-card>
      </template>
    </x-waterfall>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { AfterSalesType } from './_model'
  import { apiSaleAfterStandardEcommerceSaleAfterList } from '@/api'
  import { navigateTo } from '@/router'
  import { Track } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '退款/售后',
      })),
    ],

    props: {
      embed: {
        type: Boolean,
        default: false,
      },
      noCompleteTips: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({ AfterSalesType }),

    methods: {
      // 加载列表
      async handleLoad({ pageNumber }) {
        return apiSaleAfterStandardEcommerceSaleAfterList({
          pageIndex: pageNumber,
          pageSize: 10,
        })
      },

      // 点击条目
      handleItemClick(item) {
        navigateTo('AfterSalesDetail', {
          id: item.id,
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .hd {
    display: flex;
    align-items: center;

    .no {
      flex-grow: 1;
      font-size: 12px;
      color: #888888;
    }

    .type {
      flex-shrink: 0;
      font-size: 14px;
      color: #ff111c;
    }
  }

  .bd {
    margin-top: 12px;
    display: flex;

    .cover {
      flex-shrink: 0;
      width: 85px;
      height: 85px;
      border-radius: 8px;
      overflow: hidden;
    }

    .content {
      margin-left: 12px;
      flex-grow: 1;

      .name {
        font-size: 14px;
        color: #222222;
        line-height: 20px;
      }

      .desc {
        margin-top: 4px;
        font-size: 12px;
        color: #888888;
      }

      .extra {
        margin-top: 5px;
        font-size: 14px;
        color: #222222;
      }
    }

    .info {
      margin-left: 27px;
      flex-shrink: 0;

      .price {
        font-size: 12px;
        color: #1d1d1c;
        text-align: right;
      }

      .amount {
        margin-top: 5px;
        font-size: 12px;
        color: #888888;
        text-align: right;
      }
    }
  }

  .ft {
    margin-top: 16px;
    background: #f5f6f8;
    border-radius: 4px;
    padding: 8px 12px;
    display: flex;
    align-items: center;

    .content {
      flex-grow: 1;
      font-size: 14px;
      color: #888888;
    }

    .arrow {
      flex-shrink: 0;
      font-size: 14px;
      color: #bebebe;
    }

    &:active {
      opacity: 0.8;
    }
  }
</style>
